import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useApplication} from "../../ApplicationProvider";
import {Avatar, Box, Typography, useTheme} from "@mui/material";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import {styles} from "../login/LoginStyles";
import FilledButton from "../../components/buttons/FilledButton";
import FormTextField from "../../components/fields/FormTextField";
import FormColumn from "../../forms/FormColumn";
import {LOGIN_PATH} from "../../routes";
import {RecoverPasswordFeature} from "./RecoverPasswordFeature";
import useFeature from "../../useFeature";

function RecoverPasswordScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const theme = useTheme();
    const style = styles(theme);
    const feature = useFeature(() => new RecoverPasswordFeature(application));

    const isFeatureReady = (feature) => {
        return feature && feature.form;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        feature.recoverPassword();
    };

    const renderContent = () => (
        <Box style={style.loginContainer}>
            <Box style={style.loginBox}>
                <Box style={style.loginHeader}>
                    <Avatar style={style.avatarIcon}/>
                </Box>
                <Typography variant="h7" align="center" gutterBottom>
                    Recuperar contraseña
                </Typography>
                {feature.passwordRecovered ? (
                    <Box sx={{textAlign: 'center', mt: 2}}>
                        <Typography variant="body1" sx={{mb: 3}}>
                            Se ha enviado un correo para restablecer tu contraseña
                        </Typography>
                        <FilledButton style={style.loginButton} onClick={() => navigator(LOGIN_PATH)}>
                            Volver al inicio
                        </FilledButton>
                    </Box>
                ) : (
                    <Box onSubmit={handleSubmit} component="form" noValidate sx={style.formContainer}>
                        <FormColumn>
                            <FormTextField label="Dirección de email" field={feature.emailField()}/>
                        </FormColumn>
                        <Box sx={style.loginButtonContainer}>
                            <FilledButton type="submit" style={style.loginButton} disabled={feature.loading}>
                                Aceptar
                            </FilledButton>
                        </Box>
                        <Box sx={{textAlign: 'center', mt: 2}}>
                            <Typography variant="body2" component="span">
                                ¿Recordaste tu contraseña?{' '}
                            </Typography>
                            <Box component="span" sx={{ml: 1}}>
                                <a href={LOGIN_PATH} style={{textDecoration: 'none', color: theme.palette.primary.main}}>
                                    Iniciar sesión
                                </a>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );

    return <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={renderContent} skeleton={<></>}/>;
}

export default observer(RecoverPasswordScreen);
